import { Link } from 'react-router-dom';
import { episodes } from '@/mocks/episodes';

export default function EpisodePreview() {
  const recent = episodes.slice(-3).reverse();
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="container-site">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-block rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-900">
              分集剧情
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl">近期剧情看点</h2>
          </div>
          <Link
            to="/episodes"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 cursor-pointer"
          >
            查看全部分集
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 space-y-4">
          {recent.map((ep) => (
            <Link
              key={ep.id}
              to="/episodes"
              className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 sm:flex-row sm:items-center"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-background-50">
                第{ep.no}话
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="text-base font-semibold text-foreground-950">{ep.title}</h3>
                <p className="mt-1 line-clamp-2 text-sm leading-6 text-foreground-700">{ep.summary}</p>
              </div>
              <span className="hidden shrink-0 items-center gap-1 text-sm font-medium text-primary-700 sm:inline-flex">
                阅读详情
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}